import script from "./NotificationsDrawerPublisher.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsDrawerPublisher.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsDrawerPublisher.vue?vue&type=style&index=0&id=fc37a6c8&lang=less&scoped=true"
import "./NotificationsDrawerPublisher.vue?vue&type=style&index=1&id=fc37a6c8&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc37a6c8"]])

export default __exports__